export default {
    methods: {
        exportData (url, searchParams, fileName) {
            axios.get(url, {
                params: searchParams,
                responseType: "blob"
            }).then(response => {

                const url = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
                const link = document.createElement("a");

                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();

            }).catch(error => {
                toastr.error(error.data.message);
            });
        },
    }
};
